<ng-container *ngIf="loading">
  <div class="text-center mt-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p>Loading form, please wait...</p>
  </div>
</ng-container>

<ng-container *ngIf="!loading && error">
  <div class="alert alert-danger mt-5 text-center">
    {{ error }}
  </div>
</ng-container>

<ng-container *ngIf="!loading && !error">
  <div class="header-logo default" *ngIf="!practiceLogo">
    <img src="assets/images/logo-white.png" />
  </div>

  <div class="header-logo practice" *ngIf="practiceLogo">
    <img [src]="practiceLogo" />
  </div>
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="submit()" class="form-container">
      <div class="row">
        <div class="col-12 mb-3">
          <h2>PATIENT DETAILS</h2>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="firstName">First Name*</label>
          <input
            id="firstName"
            type="text"
            class="form-control"
            formControlName="first_name"
          />
          <div *ngIf="isInvalid('first_name')" class="validation-error">
            {{ validationErrors["first_name"] || "First Name is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="lastName">Last Name*</label>
          <input
            id="lastName"
            type="text"
            class="form-control"
            formControlName="last_name"
          />
          <div *ngIf="isInvalid('last_name')" class="validation-error">
            {{ validationErrors["last_name"] || "Last Name is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="person_title">Title</label>
          <select
            id="person_title"
            class="form-select"
            formControlName="person_title"
          >
            <option *ngFor="let title of personTitles" [value]="title">
              {{ title }}
            </option>
          </select>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="gender">Sex*</label>
          <select id="gender" class="form-select" formControlName="gender">
            <option value="">Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <div *ngIf="isInvalid('gender')" class="validation-error">
            {{ validationErrors["gender"] || "Sex is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="passportNumber">ID/Passport Number*</label>
          <input
            id="passportNumber"
            type="text"
            class="form-control"
            formControlName="passport_number"
          />
          <div *ngIf="isInvalid('passport_number')" class="validation-error">
            {{
              validationErrors["passport_number"] ||
                "ID/Passport Number is required."
            }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="birthday">Date of Birth*</label>
          <input
            id="birthday"
            type="date"
            class="form-control"
            formControlName="birthday"
          />
          <div *ngIf="isInvalid('birthday')" class="validation-error">
            {{ validationErrors["birthday"] || "Date of Birth is required." }}
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 mb-3">
          <h2>CONTACT INFORMATION</h2>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="phone">Contact Number</label>
          <input
            id="phone"
            type="text"
            class="form-control"
            formControlName="phone"
          />
          <div *ngIf="isInvalid('phone')" class="validation-error">
            {{ validationErrors["phone"] || " Please enter a valid phone number  (e.g., +27123456789)." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label for="email">Email Address</label>
          <input
            id="email"
            type="email"
            class="form-control"
            formControlName="email"
          />
          <div *ngIf="isInvalid('email')" class="validation-error">
            {{ validationErrors["email"] || "Invalid email format." }}
          </div>
        </div>
      </div>

      <div class="row mt-4" [formGroup]="addressForm">
        <div class="col-12 mb-3">
          <h3>Physical Address*</h3>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Unit Number</label>
          <input
            type="text"
            class="form-control"
            formControlName="unit_number"
          />
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Complex/Estate</label>
          <input type="text" class="form-control" formControlName="complex" />
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Street Address*</label>
          <input
            #streetInput
            id="street"
            type="text"
            class="form-control"
            formControlName="street"
          />
          <div
            *ngIf="isInvalid('street', addressForm)"
            class="validation-error"
          >
            {{ validationErrors["street"] || " Street Address is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Postal Code*</label>
          <input type="text" class="form-control" formControlName="post_code" />
          <div
            *ngIf="isInvalid('post_code', addressForm)"
            class="validation-error"
          >
            {{ validationErrors["post_code"] || "Postal Code is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>City*</label>
          <input type="text" class="form-control" formControlName="city" />
          <div *ngIf="isInvalid('city', addressForm)" class="validation-error">
            {{ validationErrors["city"] || "City is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Municipality/District*</label>
          <input
            type="text"
            class="form-control"
            formControlName="municipality"
          />
          <div
            *ngIf="isInvalid('municipality', addressForm)"
            class="validation-error"
          >
            {{
              validationErrors["municipality"] ||
                "Municipality/District is required."
            }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Province*</label>
          <input type="text" class="form-control" formControlName="province" />
          <div
            *ngIf="isInvalid('province', addressForm)"
            class="validation-error"
          >
            {{ validationErrors["province"] || "Province is required." }}
          </div>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Country*</label>
          <ng-select
            class="form-control"
            [items]="$countries | async"
            bindLabel="name"
            bindValue="id"
            formControlName="country_id"
            placeholder="Select Country"
            loadingText="Loading"
          >
          </ng-select>
          <div
            *ngIf="isInvalid('country_id', addressForm)"
            class="validation-error"
          >
            {{ validationErrors["country_id"] || " Country is required." }}
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 mb-3">
          <h2>PAYMENT INFORMATION</h2>
        </div>

        <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
          <label>Payment Type*</label>
          <select class="form-select" formControlName="payment_method_id">
            <option value="">Select Payment Type</option>
            <option *ngFor="let p of paymentTypes" [value]="p.id">
              {{ p.name }}
            </option>
          </select>
          <div *ngIf="isInvalid('payment_method_id')" class="validation-error">
            {{
              validationErrors["payment_method_id"] ||
                " Payment type is required."
            }}
          </div>
        </div>

        <ng-container *ngIf="showMedicalAidFields" [formGroup]="medicalAidForm">
          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Medical Aid Country*</label>
            <ng-select
              class="form-control"
              [items]="$countries | async"
              bindLabel="name"
              bindValue="id"
              formControlName="medical_aid_country_id"
              placeholder="Select Country"
              loadingText="Loading"
            >
            </ng-select>
            <div
              *ngIf="isInvalid('medical_aid_country_id', medicalAidForm)"
              class="validation-error"
            >
              {{
                validationErrors["medical_aid_country_id"] ||
                  " Country is required."
              }}
            </div>
          </div>

          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Scheme*</label>
            <ng-container *ngIf="schemes?.length; else customScheme">
              <ng-select
                [items]="schemes"
                bindLabel="name"
                bindValue="id"
                formControlName="medical_aid_scheme_id"
                placeholder="Select Scheme"
              ></ng-select>
              <div
                *ngIf="isInvalid('medical_aid_scheme_id', medicalAidForm)"
                class="validation-error"
              >
                {{
                  validationErrors["medical_aid_scheme_id"] ||
                    "Scheme is required."
                }}
              </div>
            </ng-container>
            <ng-template #customScheme>
              <input
                type="text"
                class="form-control"
                formControlName="custom_scheme_name"
              />
              <div
                *ngIf="isInvalid('custom_scheme_name', medicalAidForm)"
                class="validation-error"
              >
                {{
                  validationErrors["custom_scheme_name"] ||
                    "Custom Scheme is required."
                }}
              </div>
            </ng-template>
          </div>

          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Plan*</label>
            <ng-container *ngIf="schemes?.length; else customPlan">
              <select class="form-select" formControlName="medical_aid_plan_id">
                <option value="">Select Plan</option>
                <option *ngFor="let p of plans" [value]="p.id">
                  {{ p.name }}
                </option>
              </select>
              <div
                *ngIf="isInvalid('medical_aid_plan_id', medicalAidForm)"
                class="validation-error"
              >
                {{
                  validationErrors["medical_aid_plan_id"] || "Plan is required."
                }}
              </div>
            </ng-container>
            <ng-template #customPlan>
              <input
                type="text"
                class="form-control"
                formControlName="custom_plan_name"
              />
              <div
                *ngIf="isInvalid('custom_plan_name', medicalAidForm)"
                class="validation-error"
              >
                {{
                  validationErrors["custom_plan_name"] ||
                    " Custom Plan is required."
                }}
              </div>
            </ng-template>
          </div>

          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Option</label>
            <ng-container *ngIf="schemes?.length; else customOption">
              <select
                class="form-select"
                formControlName="medical_aid_option_id"
              >
                <option value="">Select Option</option>
                <option *ngFor="let o of options" [value]="o.id">
                  {{ o.name }}
                </option>
              </select>
              <div
                *ngIf="isInvalid('medical_aid_option_id', medicalAidForm)"
                class="validation-error"
              >
                {{
                  validationErrors["medical_aid_option_id"] ||
                    "Option is required."
                }}
              </div>
            </ng-container>
            <ng-template #customOption>
              <input
                type="text"
                class="form-control"
                formControlName="custom_option_name"
              />
              <div
                *ngIf="isInvalid('custom_option_name', medicalAidForm)"
                class="validation-error"
              >
                {{
                  validationErrors["custom_option_name"] ||
                    "Custom Option Name is required."
                }}
              </div>
            </ng-template>
          </div>

          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Membership Number*</label>
            <input
              type="text"
              class="form-control"
              formControlName="medical_aid_number"
            />
            <div
              *ngIf="isInvalid('medical_aid_number', medicalAidForm)"
              class="validation-error"
            >
              {{
                validationErrors["medical_aid_number"] ||
                  " Membership Number is required."
              }}
            </div>
          </div>

          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Dependent Code*</label>
            <input
              type="text"
              class="form-control"
              formControlName="dependant_code"
            />
            <div
              *ngIf="isInvalid('dependant_code', medicalAidForm)"
              class="validation-error"
            >
              {{
                validationErrors["dependant_code"] ||
                  "Dependent Code is required."
              }}
            </div>
          </div>

          <div class="form-group col-12 col-md-6 col-xl-4 mb-3">
            <label>Main Member ID Number*</label>
            <input
              type="text"
              class="form-control"
              formControlName="main_member_id"
            />
            <div
              *ngIf="isInvalid('main_member_id', medicalAidForm)"
              class="validation-error"
            >
              {{
                validationErrors["main_member_id"] ||
                  "Main Member ID Number is required."
              }}
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="profileUpdateError">
        <div class="alert alert-danger mt-2 text-center">
          {{ profileUpdateError }}
        </div>
      </ng-container>
      <button
        type="submit"
        class="btn btn-block btn-primary mt-3 mb-3"
        [disabled]="isSubmitting"
      >
        <span
          *ngIf="isSubmitting"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span *ngIf="isSubmitting">Submitting...</span>
        <span *ngIf="!isSubmitting">Submit</span>
      </button>
    </form>
  </div>
</ng-container>
